import { render, staticRenderFns } from "./MatchTableItem.vue?vue&type=template&id=188dce04&scoped=true"
import script from "./MatchTableItem.vue?vue&type=script&lang=js"
export * from "./MatchTableItem.vue?vue&type=script&lang=js"
import style0 from "./MatchTableItem.vue?vue&type=style&index=0&id=188dce04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188dce04",
  null
  
)

export default component.exports